import { Component, Input, TrackByFunction, input, output, ChangeDetectionStrategy } from "@angular/core";
import { WorkspaceSelected } from "common/workspace/workspace-selection.component";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ClickStopPropagationDirective } from "common/click-stop-propagation.directive";
import { SpinComponent } from "common/spin/spin.component";
import { HighlightMatchesPipe } from "common/collection/highlight-matches.pipe";

type Workspace = stages.workspace.Workspace;

@Component({
	selector: "stages-workspace-list",
	styleUrls: ["./workspace-list.component.scss"],
	templateUrl: "./workspace-list.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, ClickStopPropagationDirective, NgClass, SpinComponent, HighlightMatchesPipe],
})
export class WorkspaceListComponent {
	private _filterTerm?: string;

	readonly preSelected = input<string>();

	readonly workspaces = input<Workspace[]>();

	readonly bookmarkable = input<boolean>();

	readonly showEmpty = input<boolean>(true);

	readonly searchEngineAvailable = input<boolean>();

	readonly enableLocalFilter = input<boolean | undefined>(false);

	// TODO: Skipped for migration because:
	//  Accessor inputs cannot be migrated as they are too complex.
	@Input()
	set filterTerm(filterTerm: string | undefined) {
		this._filterTerm = filterTerm ? filterTerm.toLocaleLowerCase() : undefined;
	}

	get filterTerm(): string | undefined {
		return this._filterTerm;
	}

	readonly up = output<string>();

	readonly down = output<string>();

	readonly selected = output<WorkspaceSelected>();

	readonly bookmark = output<Workspace>();

	trackBy: TrackByFunction<Workspace> = (_index, workspace) => {
		return workspace.id;
	};

	toggleFavorite(workspace: Workspace): void {
		this.bookmark.emit(workspace);
	}

	selectWorkspace(workspace: Workspace): void {
		this.selected.emit(workspace as WorkspaceSelected);
	}

	getListIsEmptyProperty(): string | undefined {
		return this.filterTerm ? "navigation.workspace.filter.nothing_found" : this.showEmpty() ? "none" : undefined;
	}

	filter(workspaces?: stages.workspace.Workspace[]): stages.workspace.Workspace[] | undefined {
		return workspaces && this.enableLocalFilter()
			? workspaces.filter((workspace) => {
					return !this.filterTerm || workspace.name.toLocaleLowerCase().indexOf(this.filterTerm) >= 0;
				})
			: workspaces;
	}
}
